import axios from 'axios';
import { useSelector } from 'react-redux';
import Config from '../Config';

const useAnalytics = () => {
  const user = useSelector((state) => state.UserReducer.user);

  const trackProductClick = async (productId) => {
    try {
      await axios.post(
        `${Config.apiUrl}/analytics/track`,
        {
          product_id: productId,
          action_type: 'product_click',
        },
        {
          headers: { 
            Authorization: user?.token ? `Bearer ${user.token}` : '' // Include token if user is logged in
          },
        }
      );
    } catch (err) {
      // Ignore tracking errors in UI so it doesn't disrupt the user experience
      console.warn("Tracking failed", err);
    }
  };

  return { trackProductClick };
};

export default useAnalytics;